import React from "react";
import { useLocation } from "react-router-dom";
import Page from "./Page";

const ROUTE_LOCALE_MAP = {
  "/sicher-wachsen": "de-CH",
  "/grow-safely": "en",
};

export default function SicherWachsen() {
  const { pathname } = useLocation();
  const locale = ROUTE_LOCALE_MAP[pathname] ?? "de-CH";

  React.useEffect(() => {
    localStorage.setItem("cf_language", locale);
  }, [locale]);

  return <Page alias="sicher-wachsen" filters={{ locale }} />;
}
